import React, { ReactElement } from 'react'
import Tooltip from 'ui/components/Tooltip/Tooltip'

export type IconColor = 'primary' | 'black' | 'grey' | 'white' | 'info' | 'warning' | 'danger' | 'success'

type NewIconProps = {
  ariaLabel: string
  icon: string
  color?: IconColor
  tooltip?: { title: string; placement?: 'top' | 'bottom' | 'left' | 'right'; arrow?: boolean }
  size?: 'extraSmall' | 'small' | 'medium' | 'large'
}

const sizeClasses: Record<string, string> = {
  extraSmall: 'text-[0.5rem]', // 0.5rem
  small: 'text-xs', // 0.75rem
  medium: 'text-base', // 1rem
  large: 'text-[1.575rem]', // 1.575rem
}

const colorClasses: Record<string, string> = {
  white: 'text-white',
  black: 'text-black',
  grey: 'text-grey-5',
  primary: 'text-primary-5',
  warning: 'text-warning-4',
  danger: 'text-danger-4',
  info: 'text-info-4',
  success: 'text-success-4',
}

export default function NewIcon({
  ariaLabel,
  size = 'medium',
  color = 'primary',
  tooltip,
  icon,
}: NewIconProps): ReactElement {
  const iconElement = (
    <i
      role="img"
      aria-label={ariaLabel}
      className={`${icon} inline-flex items-center ${sizeClasses[size]} ${colorClasses[color]}`}
    />
  )

  if (tooltip?.title) {
    return (
      <Tooltip title={tooltip.title} arrow={tooltip.arrow ?? true} placement={tooltip.placement ?? 'top'}>
        {iconElement}
      </Tooltip>
    )
  }

  return iconElement
}
